export const customerLocale = {
    'zhCN': {
        customer: {
            customerName: '客户名称',
            customerSAPCode: '客户SAPCode',
            realNameAuthenticationStatus: '认证状态',
            officialSealStatus: '印章状态',
            isRegistered: '是否注册',
            isOnlineCompensation: '是否接受在线补偿',
            isHasWaitingApprovalSeal: '是否有待审批印章',
            isHasOrderSeal: '是否有订单章',
            isHasAgreementSeal: '是否有协议章',
            account: '账号',
            invitationCode: '邀请码',
            isBindWeChat: '是否绑定微信',
            whetherCancelRegister: '是否取消注册？',
            whetherUnbindWeChat: '是否解绑微信',
            cancelRegister: '取消注册',
            unbindWechat: '解绑微信',
            generateInvitationCode: '生成邀请码',
            customerInformation: '客户详细信息',
            cellphone: '手机号',
            mail: '邮箱',
            idCard: '身份证号',
            officialSeal: '印章',
            none: '印章未上传',
            selectContractor: '选择授权采购人',
            uploadOrderSeal: '上传订单印章',
            imageSizeError: '图片尺寸不能超过宽455像素，高455像素',
            approvalSeal: '查看&审核印章',
            province:'省份',
            enterpriseVerifyTime:'认证通过时间',
            realNameStatusUpdateTime:'状态更新时间',
            sealManagement: '印章管理',
            addSeal: '添加印章',
            whetherDeleteSeal: '是否删除该印章？',
            sealName: '印章名称',
            sealTag: '印章标签',
            sealCopy: '复制现有印章',
            existSeal: '现有印章',
            sealNameRequired: '请输入印章名称',
            sealTagRequired: '请选择印章标签',
            uploadSeal: '上传印章'
        }
    },
    'enUS': {
        customer: {
            customerName: 'Customer Name',
            customerSAPCode: 'Customer SAPCode',
            realNameAuthenticationStatus: 'Authentication Status',
            isRegistered: 'Is Registered',
            isOnlineCompensation: 'Is Online Compensation',
            isHasWaitingApprovalSeal: 'Is waitting approval seal',
            isHasOrderSeal: 'Is has Order Seal',
            isHasAgreementSeal: 'Is has Agreement Seal',
            account: 'Account',
            invitationCode: 'InvitationCode',
            isBindWeChat: 'Is Bind WeChat',
            whetherCancelRegister: 'Do you want to cancel the registration ?',
            whetherUnbindWeChat: 'Do you want to unbind wechat ?',
            cancelRegister: 'Cancel Register',
            unbindWechat: 'Unbind Wechat',
            generateInvitationCode: 'Generate InvitationCode',
            customerInformation: 'Customer Information',
            cellphone: 'Cell Phone',
            mail: 'Mail',
            idCard: 'ID Card',
            officialSeal: 'Official Seal',
            none: 'None',
            selectContractor: 'Select authorized purchaser',
            uploadOrderSeal: 'Upload Order Seal',
            imageSizeError: 'The image width can not more than 455px,height can not more than 455px',
            approvalSeal: 'View & Approval Seal',
            province:'Province',
            enterpriseVerifyTime:'authentication time',
            sealManagement: 'Seal Management',
            addSeal: 'Add Seal',
            whetherDeleteSeal: 'Delete this seal?',
            sealName: 'Seal Name',
            sealTag: 'Seal Tag',
            sealCopy: 'Copy Seal',
            existSeal: 'Exist Seal',
            sealNameRequired: 'Required',
            sealTagRequired: 'Required',
            uploadSeal: 'Upload Seal'
        }
    }
}
export default customerLocale



// WEBPACK FOOTER //
// ./src/locale/modules/customer.js